import React from 'react';
// Importing images for reusability
import mountainImg from '../assets/mountain.jpg';
import beachsideImg from '../assets/beachside.jpg';
import cityexImg from '../assets/cityex.jpg';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const FeaturedTrips = () => {
  const trips = [
    {
      src: mountainImg,
      alt: 'Mountain Adventure',
      title: 'Mountain Adventure',
      desc: 'Experience the thrill of climbing some of the highest peaks.',
    },
    {
      src: beachsideImg,
      alt: 'Beach Getaway',
      title: 'Beach Getaway',
      desc: 'Relax on beautiful, serene beaches with crystal-clear water.',
    },
    {
      src: cityexImg,
      alt: 'City Explorer',
      title: 'City Explorer',
      desc: 'Discover the culture and history of vibrant global cities.',
    },
  ];

  return (
    <section id="trips" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-center mb-12">Featured Trips</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {trips.map(({ src, alt, title, desc }) => (
            <div
              key={alt}
              className="bg-white rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300 cursor-pointer"
            >
              <LazyLoadImage
                src={src}
                alt={alt}
                effect="blur"
                loading="lazy"
                className="w-full h-64 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">{title}</h3>
                <p className="text-gray-700 mb-4">{desc}</p>
                <a href="#" className="text-blue-600 hover:text-blue-800">
                  Learn More &rarr;
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedTrips;
